import { render, staticRenderFns } from "./BaskoNextGenSearch.vue?vue&type=template&id=6af433b6&scoped=true"
import script from "./BaskoNextGenSearch.vue?vue&type=script&lang=js"
export * from "./BaskoNextGenSearch.vue?vue&type=script&lang=js"
import style0 from "./BaskoNextGenSearch.vue?vue&type=style&index=0&id=6af433b6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6af433b6",
  null
  
)

export default component.exports